import { Dispatch } from "redux";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { updateRelyingPartyRequest } from "@requests/axnadmin-core";
import { FormattedRelyingPartyConfig } from "@idw-types/data/relying-party-config";
import { formatRelyingPartyConfig } from "@formatters/relying-parties/relying-party-config-formatter";
import { setRelyingPartyDetails } from "@redux/actions/relying-party-details-actions";

export const updateRelyingPartyReduxRequest = (dispatch: Dispatch) => async (
    relyingParty: FormattedRelyingPartyConfig,
    companies: Array<AxnCompany>
): Promise<FormattedRelyingPartyConfig> => {
    const { data, error, body } = await updateRelyingPartyRequest(relyingParty);
    if (data?.transferObject) {
        const formattedRelyingParty = formatRelyingPartyConfig(data.transferObject, companies);
        dispatch(setRelyingPartyDetails({
            ...formattedRelyingParty,
            permissions: relyingParty.permissions
        }));
        displaySuccessModal(
            dispatch,
            resources.requests.updateRelyingParty.success.title,
            resources.requests.updateRelyingParty.success.message
        );
        return {
            ...formattedRelyingParty,
            permissions: relyingParty.permissions
        };
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.updateRelyingParty.error.title,
            resources.requests.updateRelyingParty.error.message,
            null,
            null,
            body
        );
    }

    return null;
};